import { Box } from "@mui/material";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Custom styles for the SidenavCollapse
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "../Sidenav/styles/sidenavCollapse";

import { useMaterialUIController } from "../../context";

function SidenavSubItem({ icon, name, active = false, ...rest }: any) {
  const [controller] = useMaterialUIController();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    sidenavColor,
  } = controller;

  return (
    <ListItem
      component="li"
      disableGutters
      sx={(theme: any) => ({
        display: "block",
        py: 0,
        pl: 2,
        [theme.breakpoints.up("lg")]: {
          pl: miniSidenav ? 0 : 2,
        },
      })}
    >
      <Box
        {...rest}
        sx={(theme: any) => ({
          ...collapseItem(theme, {
            active,
            transparentSidenav,
            whiteSidenav,
            darkMode,
            sidenavColor,
            miniSidenav,
          }),
          cursor: "pointer",
        })}
      >
        <ListItemIcon
          sx={(theme) =>
            collapseIconBox(theme, {
              transparentSidenav,
              whiteSidenav,
              darkMode,
              active,
              miniSidenav,
            })
          }
        >
          {typeof icon === "string" ? (
            <Icon sx={(theme) => collapseIcon(theme, { 
              active, 
              transparentSidenav, 
              whiteSidenav, 
              darkMode 
            })}>
              {icon}
            </Icon>
          ) : (
            icon
          )}
        </ListItemIcon>

        <ListItemText
          primary={name}
          primaryTypographyProps={{ fontWeight: 400 }}
          sx={(theme) =>
            collapseText(theme, {
              miniSidenav,
              transparentSidenav,
              whiteSidenav,
              active,
              darkMode,
            })
          }
        />
      </Box>
    </ListItem>
  );
}

// Typechecking props for the SidenavSubItem
SidenavSubItem.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default SidenavSubItem; 